import { combineReducers } from "redux";
import authReducer from "../features/auth/store/authSlice";
import blogReducer from "../features/blog/store/blogSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  blog: blogReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
